var map = {
	"./apple-icon.png": "a95d",
	"./background.jpg": "6a07",
	"./canon.svg": "6404",
	"./faces/face-0.jpg": "8e1c",
	"./faces/face-1.jpg": "8e52",
	"./faces/face-2.jpg": "d9fe",
	"./faces/face-3.jpg": "a4ab",
	"./favicon.png": "a171",
	"./glyphicons-halflings-regular.8988968.svg": "a1cf",
	"./layout.jpg": "05b6",
	"./new_logo.png": "c8c2",
	"./rating-star-full.svg": "d4df",
	"./rating-star-half.svg": "8f1c",
	"./rating-star-void.svg": "3b68",
	"./tim_80x80.png": "21e4",
	"./vue-logo.png": "fdbc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";